import backgroundImage1 from "./components/images/Sudoku_background.jpg";
import backgroundImage2 from "./components/images/Food_background.jpg";
import backgroundImage3 from "./components/images/Mortgage_background.jpg";
import backgroundImage4 from "./components/images/Soar_background.jpg";
import backgroundImage5 from "./components/images/News_background.jpg";
import backgroundImage6 from "./components/images/Zeus_background.jpg";
import backgroundImage7 from "./components/images/Toolkit_background.jpeg";
import backgroundImage8 from "./components/images/New Project.png";

export const projects = [
  {
    title: 'CTI Data Parsing',
    description: 'A Python-based CTI data processing platform that simultaneously parses and normalizes threat intelligence from 13 open-source feeds, outputting STIX 2.1 indicator bundles.',
    image: backgroundImage8,
    link: 'https://github.com/roy9495/CTI-Data-Parsing',
    github: 'https://github.com/roy9495/CTI-Data-Parsing',
    tags: ['Python', 'Threat Intel', 'STIX 2.1', 'PostgreSQL']
  },
  {
    title: 'Blockchain Security Audit & Threat Mitigation',
    description: 'End-to-end smart contract security auditing solution for Ethereum and Rust contracts, enforcing integer overflow checks and node infrastructure controls.',
    image: backgroundImage7,
    link: 'https://github.com/roy9495/Blockchain-Security-Audit-and-Threat-Mitigation-Framework',
    github: 'https://github.com/roy9495/Blockchain-Security-Audit-and-Threat-Mitigation-Framework',
    tags: ['Blockchain', 'Solidity', 'Rust', 'Security Audit']
  },
  {
    title: 'Microsoft EMS Deployment in Cybersecurity',
    description: 'Provides identity management, mobile device protection, and application security across enterprise infrastructures.',
    image: backgroundImage8,
    link: 'https://threatradar.vercel.app/microsoft-ems-enterprise-mobility-security-deployment-in-cybersecurity',
    github: 'https://threatradar.vercel.app/microsoft-ems-enterprise-mobility-security-deployment-in-cybersecurity',
    tags: ['Cybersecurity', 'Azure AD', 'EMS']
  },
  {
    title: 'Security Audit and Compliance Toolkit',
    description: 'Comprehensive security audit tool used to analyze and report adherence to strict compliance rules.',
    image: backgroundImage7,
    link: 'https://github.com/roy9495/Security-Audit-and-Compliance-Toolkit',
    github: 'https://github.com/roy9495/Security-Audit-and-Compliance-Toolkit',
    tags: ['Security Audit', 'Compliance', 'Toolkit']
  },
  {
    title: 'Malware Analysis of Zeus Banking Trojan',
    description: 'Deep-dive security analysis covering both static and dynamic behaviors of the Zeus financial malware family.',
    image: backgroundImage6,
    link: 'https://threatradar.vercel.app/malware-analysis-of-zeus-banking-trojan',
    github: 'https://threatradar.vercel.app/malware-analysis-of-zeus-banking-trojan',
    tags: ['Malware Analysis', 'Zeus Trojan', 'Reversing']
  },
  {
    title: 'Cyber Security News Dashboard',
    description: 'A cyber security news feed and dashboard constructed using the Dashy framework.',
    image: backgroundImage5,
    link: 'https://master--cyber-news-roy9495.netlify.app/',
    github: 'https://github.com/roy9495/dashy',
    tags: ['Dashy', 'Dashboard', 'Cyber News']
  },
  {
    title: 'SOAR-EDR project',
    description: 'Demonstration project of endpoint threat detection using LimaCharlie, Slack integration, and Tines.',
    image: backgroundImage4,
    link: 'https://threatradar.vercel.app/enhancing-cybersecurity-with-soar-edr-a-comprehensive-project-using-limacharlie-slack-and-tines',
    tags: ['SOAR', 'EDR', 'Tines', 'LimaCharlie']
  },
  {
    title: 'Mortgage Calculator',
    description: 'Interactive and user-friendly web application designed to compute mortgage payments and interest over time.',
    image: backgroundImage3,
    link: 'https://mortgage-calculator-flax.vercel.app/',
    github: 'https://github.com/roy9495/Mortgage-Calculator?tab=readme-ov-file',
    tags: ['Web Dev', 'Vite', 'React']
  },
  {
    title: 'Sudoku Solver',
    description: 'A web app utilizing backtracking algorithms to solve and visualize complex Sudoku grids.',
    image: backgroundImage1,
    link: 'https://sudoku-solver-umber.vercel.app/',
    github: 'https://github.com/roy9495/Sudoku-solver?tab=readme-ov-file',
    tags: ['Algorithms', 'React', 'Solver']
  },
  {
    title: 'Food App',
    description: 'A simple React-based application displaying nutrient information and recipe suggestions.',
    image: backgroundImage2,
    link: 'https://food-app-seven-iota.vercel.app/',
    github: 'https://github.com/roy9495/Food-App',
    tags: ['React', 'API Integration', 'CSS']
  },
];

export const certifications = [
  {
    title: 'API Penetration Testing',
    link: 'https://www.credly.com/badges/603747f8-f76a-49bd-a4d7-3af8b44c1a16/linked_in_profile',
    tags: ['Cybersecurity', 'Pentesting', 'API']
  },
  {
    title: 'API Security Fundamentals',
    link: 'https://www.credly.com/badges/41887782-60af-471b-98b8-ff1a288d0c42/public_url',
    tags: ['Cybersecurity', 'API Security']
  },
  {
    title: 'arcX Cyber Threat Intelligence',
    link: 'https://arcx.io/verify-certificate?id=746a981fef5096d0fee7f34df719edbbea7742d4&k=ffdf49a3d1444f6b90610d09fe895682',
    tags: ['Cybersecurity', 'Threat Intel', 'arcX']
  },
  {
    title: 'Qualys Vulnerability Detection & Response',
    link: 'https://drive.google.com/file/d/1Q78GqILTz7BVx_o9BdTgdWFhMX_IXDYr/view',
    tags: ['Cybersecurity', 'Vulnerability', 'Qualys']
  },
  {
    title: 'Google Cloud Cybersecurity Certificate',
    link: 'https://www.coursera.org/',
    tags: ['Cybersecurity', 'Google Cloud', 'Cloud Security']
  },
  {
    title: 'Saviynt Certified Identity Security for AI Age',
    link: 'https://saviynt.com/',
    tags: ['Cybersecurity', 'Identity Security', 'IAM']
  },
  {
    title: 'Open-Source Intelligence (OSINT)',
    link: 'https://www.credly.com/',
    tags: ['Cybersecurity', 'OSINT', 'Intelligence']
  },
  {
    title: 'Dark Web Foundations',
    link: 'https://www.credly.com/',
    tags: ['Cybersecurity', 'Dark Web', 'Privacy']
  },
  {
    title: 'Google Cybersecurity Professional Certificate',
    link: 'https://www.coursera.org/account/accomplishments/specialization/certificate/34QEMRLHGAUK',
    tags: ['Cybersecurity', 'Google', 'Professional']
  },
  {
    title: 'Ethical Hacking Essentials (EHE)',
    link: 'https://codered.eccouncil.org/certificate/20801104-f3f5-4e41-94e5-1c7e12536128?logged=true',
    tags: ['Cybersecurity', 'Ethical Hacking', 'EC-Council']
  },
  {
    title: 'Network Defense Essentials (NDE)',
    link: 'https://codered.eccouncil.org/certificate/d3eb1c6d-4021-45e7-a925-424d6b2b8374',
    tags: ['Cybersecurity', 'Network Defense', 'EC-Council']
  },
  {
    title: 'Chronicle SOAR Fundamentals',
    link: 'https://www.cloudskillsboost.google/public_profiles/76a21b72-591a-4b61-a8b1-3e45c94dc7b3/badges/10427448?utm_medium=social&utm_source=linkedin&utm_campaign=ql-social-share',
    tags: ['Cybersecurity', 'SOAR', 'Google Cloud']
  },
  {
    title: 'Jenkins',
    link: 'https://kodekloud.com/certificate-verification/81536F03B5-2D0644DF6746-8147DEA8E7/',
    tags: ['DevOps', 'CI/CD']
  },
  {
    title: 'Docker Training Course for the Absolute Beginner',
    link: 'https://kodekloud.com/certificate-verification/81536F03B5-814D7838B3-8147DEA8E7/',
    tags: ['DevOps', 'Docker', 'Containers']
  },
  {
    title: 'Golang',
    link: 'https://kodekloud.com/certificate-verification/81536F03B5-2D0414C440BC-8147DEA8E7/',
    tags: ['Coding', 'Go']
  },
  {
    title: 'Python Basics',
    link: 'https://kodekloud.com/certificate-verification/81536F03B5-814DE3A199-8147DEA8E7/',
    tags: ['Coding', 'Python']
  },
  {
    title: 'GIT for Beginners',
    link: 'https://kodekloud.com/certificate-verification/81536F03B5-814D691D25-8147DEA8E7/',
    tags: ['DevOps', 'Git']
  },
  {
    title: 'Responsive Web Design',
    link: 'https://www.freecodecamp.org/certification/Tathagata_Roy/responsive-web-design',
    tags: ['Web Dev', 'Responsive Design', 'freeCodeCamp']
  },
];

export const blogs = [
  {
    title: 'Malware Analysis of Zeus Banking Trojan',
    description: 'Analyzing both static and dynamic behaviors of the banking trojan to map execution pathways and API hooking techniques.',
    link: 'https://threatradar.vercel.app/malware-analysis-of-zeus-banking-trojan',
    tags: ['Malware Research', 'Reverse Engineering']
  },
  {
    title: 'LLMNR Poisoning & Network Forensics',
    description: 'Walkthrough of a network forensics challenge investigating LLMNR poison requests and packet capturing techniques.',
    link: 'https://threatradar.vercel.app/htb-noxious-walkthrough-llmnr-poisoning-network-forensics',
    tags: ['Network Forensics', 'HTB Writeup']
  },
  {
    title: 'User with a Non-Interactive Shell on Linux',
    description: 'Step-by-step guide explaining how to provision Linux accounts restricting user logins to non-interactive console shells.',
    link: 'https://threatradar.vercel.app/how-to-create-a-user-with-a-non-interactive-shell-on-linux',
    tags: ['Linux Security', 'SysAdmin']
  },
  {
    title: 'Mastering SELinux',
    description: 'Mastering security-enhanced Linux configurations to enforce fine-grained mandatory access controls over processes.',
    link: 'https://threatradar.vercel.app/mastering-selinux-a-comprehensive-guide-to-enhancing-linux-security-with-mandatory-access-control',
    tags: ['Linux Security', 'SELinux']
  },
  {
    title: 'Enhancing Cybersecurity with SOAR-EDR',
    description: 'Building an automated threat alert pipeline using LimaCharlie agents, Tines workflows, and Slack reporting channels.',
    link: 'https://threatradar.vercel.app/enhancing-cybersecurity-with-soar-edr-a-comprehensive-project-using-limacharlie-slack-and-tines',
    tags: ['SOAR', 'EDR', 'Automation']
  },
  {
    title: '1Password Shell Plugin for Docker',
    description: 'Securing containerized developer workflows by dynamically injecting credentials from 1Password vaults into Docker CLI.',
    link: 'https://threatradar.vercel.app/enhance-your-docker-workflow-with-the-1password-cli-shell-plugin',
    tags: ['DevOps', 'Docker', 'Secrets']
  },
  {
    title: 'A Guide to Sign Your GitHub Commits',
    description: 'Ensure source code integrity and prevent impersonation by cryptographically signing Git commits using SSH keys.',
    link: 'https://threatradar.vercel.app/a-guide-to-sign-your-github-commits-ensure-integrity-and-traceability',
    tags: ['Git Security', 'GPG']
  },
  {
    title: 'Git Squash',
    description: 'A tutorial on squashing redundant commits to preserve clean, concise, and structured history workflows in Git.',
    link: 'https://threatradar.vercel.app/git-squash-streamline-commit-history-for-cleaner-code-management',
    tags: ['Git', 'DevOps']
  },
];

export const workExperience = [
  {
    company: 'Suronex.ai',
    role: 'Cloud Security Analyst',
    type: 'Full-Time',
    duration: 'Oct 2025 – Present',
    points: [
      'Perform cloud security control mapping across GCP, Azure, AWS, and OCI to ensure compliance with organizational security standards and ISMS readiness.',
      'Administer M365 environments and conduct smoke testing to validate security configurations across cloud-native services.',
      'Support GRC activities by mapping controls to NIST, CIS, and internal security frameworks, reducing compliance gaps.'
    ],
    skills: ['Cloud Security', 'GRC', 'M365 Admin', 'ISMS', 'NIST', 'CIS Benchmarks']
  },
  {
    company: 'Wibix Consultancy',
    role: 'Cloud Security Researcher',
    type: 'Intern',
    duration: 'Apr 2025 – Sep 2025',
    points: [
      'Engineered a Cyber Threat Intelligence (CTI) harvesting pipeline to automatically fetch and normalize IOCs (IPs, domains, hashes) from OSINT and threat feeds.',
      'Performed CIS Benchmark mapping for cloud environments, identifying configuration gaps and providing actionable remediation guidance.',
      'Conducted cloud security control mapping to align organizational practices with industry standards.'
    ],
    skills: ['CTI', 'Threat Intelligence', 'OSINT', 'Cloud Mapping', 'CIS Benchmarks']
  },
  {
    company: 'Afterquery (YC Backed)',
    role: 'Security Engineer',
    type: 'Contract',
    duration: 'Apr 2025',
    points: [
      'Identified complex vulnerabilities in logic-heavy Python, JavaScript, SQL, and TypeScript codebases; assigned CWE IDs and CVSS severity scores.',
      'Delivered clear root-cause analysis and impact assessments for each vulnerability, and developed minimal, targeted security patches.'
    ],
    skills: ['Security Engineering', 'Vulnerability Assessment', 'CWE', 'CVSS', 'Code Review']
  },
  {
    company: 'TCR Security',
    role: 'Penetration Tester',
    type: 'Intern',
    duration: 'Oct 2024 – Apr 2025',
    points: [
      'Conducted penetration testing against Linux, Windows, and Web servers using industry-standard Kali Linux toolset including Nmap, Dirbuster, and BloodHound.',
      'Documented findings with severity ratings and delivered remediation recommendations to client teams.'
    ],
    skills: ['Penetration Testing', 'Kali Linux', 'Nmap', 'BloodHound', 'Vulnerability Reporting']
  },
  {
    company: 'The Red Users',
    role: 'Cybersecurity Analyst',
    type: 'Intern',
    duration: 'Oct 2024',
    points: [
      'Monitored and analyzed network traffic using Wireshark and Nmap; configured Windows Defender Firewall rules to harden endpoint security.',
      'Conducted web application security testing using OWASP ZAP, identifying and reporting vulnerabilities aligned to OWASP Top 10.'
    ],
    skills: ['Traffic Analysis', 'Wireshark', 'OWASP ZAP', 'Firewall Hardening']
  },
  {
    company: 'Canonical / Multipass',
    role: 'Open Source Contributor',
    type: 'Open Source',
    duration: 'Aug 2024',
    points: [
      'Resolved VM lifecycle state confusion by improving error messaging for restart and start commands, enhancing user security awareness.'
    ],
    skills: ['Virtual Machines', 'Multipass', 'Open Source', 'Error Handling']
  },
  {
    company: '1Password',
    role: 'Open Source Contributor',
    type: 'Open Source',
    duration: 'Jun 2023 – Sep 2023',
    points: [
      'Developed a Docker Shell plugin to extend CLI support in container environments; modified CLI to skip Sentry auth for improved operational security.'
    ],
    skills: ['Docker', 'CLI Tools', 'Secrets Management', 'Plugin Development']
  },
  {
    company: 'Perycap (Finance)',
    role: 'Equity Analyst',
    type: 'Full-Time',
    duration: 'Dec 2018 – Sep 2020',
    points: [
      'Analyzed NASDAQ, NYSE, and AMEX equities; developed and back-tested algorithmic trading strategies.'
    ],
    skills: ['Financial Analysis', 'Algorithms', 'Trading Strategies']
  }
];

export const education = [
  {
    school: 'Quantic School of Business & Technology',
    degree: 'M.S. in Software Engineering',
    duration: 'Sep 2025 – Present',
    details: 'Coursework: Cloud Applications & Architectures, Software Testing, CI/CD, Web Application Security, Performance Monitoring.'
  },
  {
    school: 'Dr. B C Roy Engineering College',
    degree: 'B.E. in Applied Electronics & Instrumentation',
    duration: 'Aug 2012 – Jul 2016',
    details: 'Relevant Areas: Microprocessors, Microcontrollers, Robotics, Control Systems. Final project: Automatic Ultrasonic Headway Control for Robotic Car.'
  }
];

export const accomplishments = [
  'Ranked 310th globally in CTF challenge organized by EC-Council & Hackerverse, demonstrating competitive threat analysis and exploitation skills.',
  'Top scorer (AMCAT exam, Jan–Apr 2023 session).',
  'TryHackMe — Completed ~30 rooms covering SOC, SIEM, threat hunting, and incident response scenarios.',
  'HackTheBox — Active profile with CTF and machine completions across web, binary, and network categories.'
];
